import React, { useState } from "react";
import styles from "./Question.module.scss";
import IconChevron from "../../common/icons/IconChevron";

const Question = ({ question, authors, chain }) => {
  const [isOpen, setIsOpen] = useState(true);
  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const FormatDate = (date) => {
    const formattedDate = new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return formattedDate;
  };
  const formattedAnswer = (originalAnswer) => {
    try {
      if (!originalAnswer) return "";

      let spacedAnswer = originalAnswer
        .replace(/</g, " <")
        .replace(/>/g, "> ");

      let parser = new DOMParser();
      const htmlDoc = parser.parseFromString(spacedAnswer, "text/html");

      [...htmlDoc.getElementsByTagName("a")].forEach((el, i) => {
        el.setAttribute("target", `_blank`);
      });
      return htmlDoc.body.innerHTML;
    } catch (error) {
      return "";
    }
  };
  const contentAttr = ({ item, lngs = ["fr"], lang }) => {
    if (lang) {
      let val = `content${lang.charAt(0).toUpperCase() + lang.slice(1)}`;
      if (item[val] && item[val].length === 0 && lang.length > 0) {
        return contentAttr({
          item,
          lngs: lngs.filter((el) => el !== lang),
          lang: lngs[0],
        });
      }
      return item[val];
    }
    return "";
  };
  // const headlineAttr = ({ item, lngs = ["fr"], lang }) => {
  //   if (lang) {
  //     let val = `headline${lang.charAt(0).toUpperCase() + lang.slice(1)}`;
  //     if (item[val] && item[val].length === 0 && lang.length > 0) {
  //       return headlineAttr({
  //         item,
  //         lngs: lngs.filter((el) => el !== lang),
  //         lang: lngs[0],
  //       });
  //     }
  //     return item[val];
  //   }
  //   return null;
  // };
  const titleAttr = ({ item, lngs = ["fr"], lang }) => {
    if (lang) {
      let val = `title${lang.charAt(0).toUpperCase() + lang.slice(1)}`;
      if (item[val] && item[val].length === 0 && lang.length > 0) {
        return titleAttr({
          item,
          lngs: lngs.filter((el) => el !== lang),
          lang: lngs[0],
        });
      }
      return item[val];
    }
    return "";
  };

  return (
    <div className={styles.container} id={`q-${question?.id}`}>
      <div className={styles.top} onClick={toggleOpen}>
        <div className={styles.title}>
          {titleAttr({ item: question, lang: "fr" })}
        </div>
        <div className={styles.arrow}>
          <IconChevron isOpen={isOpen} />
        </div>
      </div>
      {isOpen && (
        <>
          <div className={styles.content}>
            {question?.answers?.length > 0 ? (
              <div className={styles.answerContainer}>
                {question.answers.map((answer) => (
                  <div
                    key={answer?.id}
                    className={styles.description}
                    dangerouslySetInnerHTML={{
                      __html: formattedAnswer(
                        contentAttr({ item: answer, lang: "fr" })
                      ),
                    }}
                  ></div>
                ))}
              </div>
            ) : (
              <div className={styles.answerContainer}>
                <div className={styles.description}>
                  Aucune réponse disponible pour cette question.
                </div>
              </div>
            )}
          </div>

          {(chain || (authors?.length > 0 && authors.some(author => author?.enableAvatar))) && (
            <div className={styles.chain_author}>
              {chain && (
                <div
                  className={styles.chain}
                  style={{
                    backgroundImage: `url(${chain?.mediaChain?.[0]?.avatarUrl})`,
                  }}
                ></div>
              )}
              {authors?.length > 0 && (
                <div className={styles.authorsContainer}>
                  {authors
                    .filter(author => author?.enableAvatar)
                    .map((author, index) => (
                      <div key={`author-${author?.id}-${index}`} className={styles.author}>
                        <img
                          className={styles.authorImg}
                          src={author?.avatarUrl}
                          alt={`${author?.firstName} ${author?.lastName}`}
                        />
                        <div className={styles.authorInfo}>
                          <div className={styles.authorName}>
                            {author?.firstName} {author?.lastName}
                          </div>
                          {author?.authorDetails?.headlineFr?.title && (
                            <div className={styles.authorRole}>
                              {author.authorDetails.headlineFr.title}
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
          )}

          <div className={styles.last_update}>
            Dernière mise à jour le {question?.updatedAt ? FormatDate(question.updatedAt.date) : FormatDate(question?.createdAt?.date)}
          </div>
        </>
      )}
    </div>
  );
};

export default Question;
